"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkboxWithDigitalHig = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _svgIcon = _interopRequireDefault(require("@digital-hig/svg-icon"));

var _checkmark = _interopRequireDefault(require("@digital-hig/icon/lib/build/ui-controls/checkmark"));

var _indeterminate = _interopRequireDefault(require("@digital-hig/icon/lib/build/ui-controls/indeterminate"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Makes a Digital HIG checkbox component using the provided MUICheckbox as base
 */
var checkboxWithDigitalHig = function checkboxWithDigitalHig(BaseMuiCheckbox) {
  var Checkbox = function Checkbox(_ref) {
    var className = _ref.className,
        error = _ref.error,
        size = _ref.size,
        otherProps = _objectWithoutProperties(_ref, ["className", "error", "size"]);

    // https://mui.com/api/checkbox//
    // List out complete MUI API props and fillout values for props that will be
    // preset in the component; all the others will be received from the parent
    var muiCheckboxApiPresets = {
      // checked,
      checkedIcon: /*#__PURE__*/_react.default.createElement(_svgIcon.default, null, /*#__PURE__*/_react.default.createElement(_checkmark.default, null)),
      // classes,
      // color,
      // defaultChecked,
      // disabled,
      // disableRipple (already disabled at theme level)
      icon: /*#__PURE__*/_react.default.createElement(_svgIcon.default, null),
      // id,
      // indeterminate,
      indeterminateIcon: /*#__PURE__*/_react.default.createElement(_svgIcon.default, null, /*#__PURE__*/_react.default.createElement(_indeterminate.default, null)) // inputProps,
      // inputRef,
      // onChange,
      // required,
      // size
      // sx
      // value

    };
    var classnames = className && className.split(" ") || [];

    if (error) {
      classnames.push("DhigCheckbox--error");
    }

    classnames.push("DhigCheckbox--size--".concat(size));
    return /*#__PURE__*/_react.default.createElement(BaseMuiCheckbox, _extends({}, muiCheckboxApiPresets, otherProps, {
      className: classnames.join(" "),
      size: size
    }));
  };

  Checkbox.displayName = "Checkbox";
  Checkbox.defaultProps = {
    className: "",
    error: false,
    size: _constants.sizes.MEDIUM
  };
  Checkbox.propTypes = {
    className: _propTypes.default.string,
    error: _propTypes.default.bool,
    size: _propTypes.default.oneOf(_constants.availableSizes)
  };
  return Checkbox;
};

exports.checkboxWithDigitalHig = checkboxWithDigitalHig;
var Checkbox = checkboxWithDigitalHig(_Checkbox.default);
var _default = Checkbox;
exports.default = _default;